export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';
//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';


//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

//Slider Route
export const GET_SLIDER = '/slider/list';
export const DELETE_SLIDER = '/slider/delete/';
export const EDIT_SLIDER = '/slider/edit/';

//Gallery Route
export const GET_GALLERY = '/gallery/list';
export const DELETE_GALLERY = '/gallery/delete/';
export const EDIT_GALLERY= '/gallery/edit/';
export const DELETE_IMAGE = '/gallery/image/delete/';

//CMS Route
export const GET_CMS = '/cms/list';
export const CMS_EDIT = '/cms/edit/';
export const CMS_DELETE = '/cms/delete/';


//Offices Route
export const GET_Offices = '/office/list';
export const DELETE_OFFICE = '/office/delete/';
export const EDIT_OFFICE = '/office/edit/';

//Offices Route
export const GET_WIDGET = '/widget/list';
export const DELETE_WIDGET = '/widget/delete/';
export const EDIT_WIDGET = '/widget/edit/';

//Our Team Route
export const GET_TEAM = '/our-team/list';
export const DELETE_TEAM = '/our-team/delete/';
export const EDIT_TEAM = '/our-team/edit/';

//Blog Category Route
export const GET_BLOG_CATEGORY = '/blog/category/list';
export const DELETE_BLOG_CATEGORY = '/blog/category/delete/';
export const EDIT_BLOG_CATEGORY = '/blog/category/edit/';

//Blog Route
export const GET_BLOG = '/blog/list';
export const DELETE_BLOG = '/blog/delete/';
export const EDIT_BLOG = '/blog/edit/';

//Blog Category Route
export const GET_SERVICE_CATEGORY = '/service/category/list';
export const DELETE_SERVICE_CATEGORY = '/service/category/delete/';
export const EDIT_SERVICE_CATEGORY = '/service/category/edit/';

//Blog Route
export const GET_SERVICE = '/service/list';
export const DELETE_SERVICE = '/service/delete/';
export const EDIT_SERVICE = '/service/edit/';

//Blog Route
export const GET_CONTACT = '/contact/list';